import React from 'react';
import './SkeletonBox.scss';

const SkeletonBox = ({
    className, style
}) => {
    const clsNames = [
        'ds-skeleton-box skeleton-box ',
        (className ? className : '')
    ].join(' ');
    return (
        <span
            style={{...(style || {})}}
            className={clsNames}></span>
    );
};

export default SkeletonBox;